import * as cpo from "./cpo";
import * as oet from "./oet";
import * as run from "./run";

export default {
    cpo,
    oet,
    run
};
